<template>
    <div class="crypto-wallet-page">
        <div class="loading-box" v-if="loading">
          <van-loading size="34px"/>
      </div>
        <!-- 顶部导航栏 -->
        <div class="header">
            <van-nav-bar :title="$t('my.my_balance')" class="nav-bar">
                <template #left>
                    <van-icon name="arrow-left" color="#fff" @click="back()" />
                </template>
            </van-nav-bar>
        </div>
        <div style="height:13vw"></div>

        <!-- 页面主体内容 -->
        <div class="page-content">
            <h2 class="sub-title">{{ $t('my.setWithdrawal') }}</h2>

            <!-- 资产只读框 -->
            <!-- <div class="form-item">
                <div class="form-label">{{ $t('types') }}</div>
                <div class="form-value-box" style="background: #FFD3ED;">{{ selectCoin }}</div>
            </div> -->
            <div class="form-label" style="margin-bottom: 5px !important;">{{ $t('types') }}</div>
            <!-- 币种切换按钮组 -->
            <div class="coin-btn-group">
                <button v-for="item in coinList" :key="item.key" class="coin-btn"
                    :class="{ active: selectCoin === item.key }" @click="selectFun(item)">
                    {{ item.label }}
                </button>
            </div>

            <!-- 网络只读框 -->
            <div class="form-item">
                <div class="form-label">{{ $t('Network') }}</div>
                <div class="form-value-box">{{ selectCoinFun(selectCoin) }}</div>
            </div>

            <!-- 钱包地址只读框 -->
            <div class="form-item">
                <div class="form-label">{{ $t('WalletAddress') }}</div>
                <input class="form-input" v-model="walletAddress" :placeholder="$t('qsrAdress')" type="text" />
            </div>

            <!-- 支付密码输入框 -->
            <!-- <div class="form-item">
                <div class="form-label">{{ $t('payPass') }}</div>
                <input class="form-input" v-model="payPassword" :placeholder="$t('qsrPay')" type="password" />
            </div> -->

            <!-- 底部提示文案 -->
            <div class="tip-text">
                {{ $t('MakeSure') }}
            </div>

            <!-- 保存按钮 -->
            <div style="width:100%;padding: 10px;;">
                <button class="save-btn" @click="handleSaveWallet">{{ $t('save') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CryptoWallet',
    data() {
        return {
            loading:true,
            // 币种选项列表
            coinList: [
                { key: '0', label: 'USDT-ERC20', address: '' },
                { key: '1', label: 'USDT-TRC20', address: '' },
                { key: '2', label: 'BTC', address: '' },
                { key: '3', label: 'ETH', address: '' },
                { key: '4', label: 'USDC-ERC20', address: '' },
            ],
            // 默认选中BTC
            selectCoin: '0',
            // 默认钱包地址
            walletAddress: '',
            // 支付密码绑定值
            payPassword: ''
        }
    },
    mounted() {
        this.$http({
            method: 'get',
            url: 'getUserAddressInfo'
        }).then(res => {
            res.data.info.forEach(e => {
                this.coinList.forEach(x => {
                    if(e.type === Number(x.key)){
                        x.address = e.address
                        if(Number(x.key) === 0) {
                            this.walletAddress = x.address
                        }
                    }
                })
            })
            this.loading = false
        })
    },
    methods: {
        selectFun(item) {
            this.selectCoin = item.key
            this.walletAddress = item.address
        },
        selectCoinFun(val) {
            let item = this.coinList.find(x => x.key === val)
            return item.label
        },
        back() {
            return window.history.back();
        },
        // 保存钱包信息事件
        handleSaveWallet() {
            const formData = {
                type: this.selectCoin,
                address: this.walletAddress,
            }
            this.loading = true
            // console.log('提交保存钱包数据：', formData)
            this.$http({
                method: 'post',
                url: 'setAddress',
                data: formData
            }).then(res => {
                if (res.code === 200) {
                    this.$toast(res.msg);
                    setTimeout(() => {
                        this.$router.back()
                    },1500)
                } else if (res.code === 401) {
                    this.$toast(res.msg);
                    setTimeout(() => {
                        localStorage.clear()
                        this.$router.push({ path: '/Login' })
                    },1500)
                }else {
                    this.$toast(res.msg);
                }
                this.loading = false
            }).catch(err => {
                this.loading = false
                this.$toast(err);
            })
        }
    }
}
</script>

<style scoped lang="less">
.header {
    height: 13vw;
    background: linear-gradient(30deg, #7d76ef, #d63f8c);
}

.title {
    font-size: 4vw;
    width: 100%;
    padding: 3vw 2vw 2vw 2vw;
    text-align: center;
    font-weight: bold;
}

.header_content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin: 0 40px;
    color: #fff;
    position: relative;

    .img {
        height: 80px;

        img {
            width: 100%;
            height: 100%;
        }
    }
}


/* 全局页面基础样式 */
.crypto-wallet-page {
    background-color: #fff;
    min-height: 100vh;
    color: #f8d8b8;
    font-family: system-ui, -apple-system, sans-serif;
    padding-bottom: 40px;
}

/* 顶部导航栏 */
.back-btn {
    font-size: 22px;
    color: #f8d8b8;
    cursor: pointer;
    margin-right: 20px;
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);
}

.header-title {
    margin: 0;
    font-size: 24px;
    font-weight: 500;
    color: #f8d8b8;
}

/* 内容容器 */
.page-content {
    padding: 24px 16px;
}

.sub-title {
    width: 100%;
    word-break: keep-all;
    font-size: 36px;
    font-weight: 600;
    margin: 0 0 14px;
    color: #000000;
}

/* 表单通用项 */
.form-item {
    margin-bottom: 30px;
}

.form-label {
    font-size: 30px;
    margin-bottom: 8px;
    color: #000;
}

.form-value-box {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 14px;
    background: #ffffff;
    border-radius: 10px;
    font-size: 30px;
    color: #000;
    border: 1px solid #444;
}

.form-input {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 14px;
    background: #ffffff;
    border-radius: 10px;
    font-size: 30px;
    color: #000000;
    border: 1px solid #444;
    outline: none;
}

/* 币种按钮组布局 */
.coin-btn-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    margin: 0px 0px 20px 0px;
}

.coin-btn {
    padding: 16px 8px;
    background: #ffffff;
    border: 1px solid #C44BA1;
    border-radius: 10px;
    color: #C44BA1;
    font-size: 28px;
    cursor: pointer;
    transition: all 0.2s;
}

.coin-btn.active {
    background: linear-gradient(30deg, #7d76ef, #d63f8c);
    border-color: #d49763;
    color: #fff;
}

/* 底部提示文字 */
.tip-text {
    font-size: 28px;
    line-height: 1.5;
    color: #ac921e;
    margin: 30px 0 40px;
}

/* 底部保存按钮 */
.save-btn {
    width: 100%;
    padding: 20px;
    border-radius: 38px;
    background: linear-gradient(90deg, #e6c3a1, #7e5678);
    border: none;
    font-size: 30px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
}
.loading-box {
    width: 100%;
    height: 100%;
    position: fixed;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20%;
}
</style>